@if(!isCreatingConnectionLoading){
<div class="w-[700px]">
  <div class="flex justify-between items-center p-4 border-b">
    <p class="m-0 font-semibold text-base">
      {{ data.userDetails?.first_name ? 'Edit ' + data.userDetails.first_name : 'Create New User' }}
    </p>

    <span class="material-icons search-icon text-k-black font-bold cursor-pointer text-base" (click)="closeDialog()"> close </span>
  </div>
  <div class="flex justify-between px-6 py-5 mt-0 flex-col gap-8 pb-0" (click)="$event.stopPropagation()">
    @if (!!hasGuardianAccess) {
    <div class="rounded-lg border-dashed border border-[#7e9bd4] h-[162px] w-[164px]">
      @if (user$ | async; as user) {
      <div class="user__profile--info--wrapper h-full m-0 relative w-full">
        <input
          type="file"
          class="hidden w-full h-full"
          #fileUpload
          (change)="fileChangeEvent($event)"
          id="fileUpload"
          name="fileUpload"
          accept="image/png,  image/jpeg"
        />
        <!-- <div
                class="user__profile--image--wrapper h-full items-center"
                *ngIf="user?.profile_image_url; else initialLoader"
                (click)="fileUpload.click()"
                > -->
        <div class="user__profile--image--wrapper h-full items-center w-full" (click)="fileUpload.click()">
          <span>
            <!-- (click)="fileUpload.click()" -->
            <img class="user__profile--edit--image" src="/assets/images/change-profile.svg" />
          </span>
          <img
            class="user__profile--image w-20 h-20"
            [src]="pendingImgSrc ? pendingImgSrc : '/assets/images/admin-light-grey.png'"
            name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
          />
        </div>
        <ng-template #initialLoader>
          @if (user.first_middle_name || user.last_name) {
          <div class="user__profile--image--wrapper">
            <span (click)="fileUpload.click()">
              <img class="user__profile--edit--image" src="/assets/images/change-profile.svg" />
            </span>
            <ngx-avatars
              size="112"
              [src]=""
              name="{{ user?.first_middle_name + ' ' + user?.last_name | titlecase }}"
              [round]="true"
              initialsSize="2"
            ></ngx-avatars>
          </div>
          } @else {
          <ng-template [ngTemplateOutlet]="showinitialLoader"></ng-template>
          }
        </ng-template>
      </div>
      } @else {
      <div class="ph-item sm:items-center h-full p-0 border-0">
        <div class="ph-col-12 m-auto">
          <div class="ph-avatar flex fl-al-center w-[85px] h-[85px] m-0 mx-auto"></div>
        </div>
      </div>
      }
    </div>
    }
    <div [class]="!hasGuardianAccess ? 'w-full' : 'w-full'">
      <form class="w-full" [formGroup]="connectionForm">
        @if (!hasGuardianAccess){
        <div class="flex gap-2 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important">
            <mat-label class="automtic-form-desing-lable">Full Name</mat-label>
            <input required matInput placeholder="Full Name" formControlName="full_name" />
            @if (connectionForm.controls['full_name'].value == '') {
            <mat-error>Full name is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important">
            <mat-label class="automtic-form-desing-lable"> email</mat-label>
            <input matInput placeholder="Email" required formControlName="email" />
            @if (connectionForm.controls['email'].value == '') {
            <mat-error>email is required</mat-error>
            } @if (connectionForm.controls['email'].value !== '' && connectionForm.controls['email'].invalid) {
            <mat-error>email is invalid</mat-error>
            }
          </mat-form-field>
        </div>
        }@else {
        <div class="flex gap-2 items-center">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important">
            <mat-label class="automtic-form-desing-lable">First Name</mat-label>
            <input required matInput placeholder="First Name" formControlName="first_name" />
            @if (connectionForm.controls['first_name'].value == '') {
            <mat-error>First name is required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important">
            <mat-label class="automtic-form-desing-lable"> Last Name</mat-label>
            <input matInput placeholder="Last Name" required formControlName="last_name" />
            @if (connectionForm.controls['last_name'].value == '') {
            <mat-error>Last name is required</mat-error>
            }
          </mat-form-field>
        </div>
        }

        <div class="flex gap-2 items-start">
          <mat-form-field appearance="fill" style="width: 100%; margin-bottom: 5px !important">
            <mat-label class="automtic-form-desing-lable"> Nickname (optional)</mat-label>
            <input matInput placeholder="Nickname" formControlName="your_self" />
          </mat-form-field>

          <reusable-date-input
            [ngClass]="'w-full'"
            [classStyle]="'connection_form automtic-form-desing-form-only add-automtic-form-desing w-full'"
            [title]="'Date of Birth'"
            [hasMaxDate]="true"
            [controlName]="'birthdate'"
            [maxDate]="today"
            [value]="this.connectionForm.controls['dateOfBirth'].value"
            (changeEmitter)="logDate($event)"
            (dateChangeEmitter)="logDate2($event)"
            [appearance]="'fill'"
          >
          </reusable-date-input>
          <!-- <mat-form-field
              appearance="fill"
              style="width: 50% !important; max-width: 50%"
              class="connection_form automtic-form-desing-form-only add-automtic-form-desing"
            >
              <mat-label class="automtic-form-desing-lable"> Date of Birth </mat-label>
              <input
                matInput
                placeholder="Date Of Birth"
                [value]="this.connectionForm.controls['dateOfBirth'].value"
                formControlName="dateOfBirth"
                style="display: none"
              />
              <input
                matInput
                placeholder="Date Of Birth"
                [matDatepicker]="dp"
                (dateChange)="logDate($event.value)"
                style="display: none"
                [max]="today"
              />
  
              {{
                this.connectionForm.controls['dateOfBirth'].value == ''
                  ? ''
                  : this.connectionForm.controls['dateOfBirth'].value !== 'Not filled' && this.connectionForm.controls['dateOfBirth'].value !== ''
                  ? this.moment(this.connectionForm.controls['dateOfBirth'].value).format('MMM DD, YYYY')
                  : 'Not filled'
              }}
              <mat-datepicker-toggle matSuffix [for]="dp" style="position: relative; top: 4px">
                <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field> -->
        </div>
        <div class="flex gap-2 items-center">
          <div style="width: 100% !important; max-width: 100%">
            <connect-relationship-dialog
              [hideText]="true"
              (onDatePicked)="doSomething($event)"
              [fromInvite]="true"
              [data]="connection_relationship_data"
              [isGuardian]="false"
              [selectedRelationship]="selectedRelationship"
              [subMemberPlaceHolder]="'Relationship Type'"
              [isConnectionModalBtn]="true"
              (relationshipId)="relationshipIdChanged()"
              [filterList]="data.filterList"
              [relationshipData]="data.userDetails"
            >
            </connect-relationship-dialog>
          </div>
          <mat-form-field appearance="fill" class="app__form--select--field w-full">
            <mat-label class="automtic-form-desing-lable">Is this person Alive?</mat-label>
            <mat-select formControlName="has_passed_away" (selectionChange)="onAliveStatusChange($event)">
              <mat-option value="Yes">Yes</mat-option>
              <mat-option value="No">No</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex gap-2 items-center">
          @if (connectionForm.controls['has_passed_away'].value === 'No') {
          <div style="width: 50% !important; max-width: 50%">
            <reusable-date-input
              [ngClass]="'w-full'"
              [classStyle]="'connection_form automtic-form-desing-form-only add-automtic-form-desing w-full'"
              [title]="'Date of Passing'"
              [hasMaxDate]="true"
              [controlName]="'has_passed_away_date'"
              [maxDate]="today"
              [value]="connectionForm.controls['has_passed_away_date'].value"
              (changeEmitter)="logDateOfPassing($event)"
              (dateChangeEmitter)="logDateOfPassing($event)"
              [appearance]="'fill'"
            >
            </reusable-date-input>
          </div>
          }
        </div>
      </form>
    </div>
  </div>
  <hr class="mt-0" />
  <div class="flex w-full justify-end p-4 bottom-0 my-2 pt-0 mt-0 mb-0">
    <button
      [class]="
        connectionForm.valid && connectionForm.controls['relationship_type'].value
          ? 'app__btn--primary rounded-md w-[76px] h-8 flex items-center justify-center m-0 p-0 text-sm'
          : 'app__btn--disabled rounded-md w-[76px] h-8 flex items-center justify-center m-0 p-0 text-sm'
      "
      (click)="
        $event.stopPropagation();
        connectionForm.valid && connectionForm.controls['relationship_type'].value ? (data.userDetails ? editGuardian() : submitForm()) : ''
      "
    >
      Save
    </button>
  </div>
</div>

}@else{
<create-account-placeholder-component
  [username]="
    hasGuardianAccess
      ? (!!connectionForm.controls['your_self'].value && connectionForm.controls['your_self'].value.trim() !== ''
          ? connectionForm.controls['your_self'].value
          : connectionForm.controls['first_name'].value) +
        ' ' +
        connectionForm.controls['last_name'].value
      : connectionForm.controls['full_name'].value
  "
></create-account-placeholder-component>
}
